import { DoorSize } from './door-size';

export interface IDoorSizeOption {
    id: DoorSize;
    description: string;
}


export class DoorSizeOption implements IDoorSizeOption {
    public id: DoorSize = DoorSize.Indeterminate;
    public description: string = '';
}


